module.exports = __webpack_public_path__ + "img/dl-icon.fbfd4b67.svg";